export const APP_PERMISSION = process.env.REACT_APP_SIGNIN_PERMISSION || 'esignature';

export const PERMISSION = Object.freeze({
    ADMIN: `${APP_PERMISSION}.admin`,
});